import React, { useMemo } from "react";
import ReferencesList from "./ReferencesList";
import styles from "./index.module.less";
import type { IThinkReference } from "../ThinkingProcessV2";
import type { ISegment } from "@typing/wsui/getMessages";

/**
 * 引用文献抽屉组件Props
 */
interface IReferencesDrawerProps {
    visible: boolean;
    segment: ISegment | null;
    messageId: string;
    anchorIndex: string | null;
    paragraphIndex: number | null;
    triggerTimestamp?: number | null;
    onClose: () => void;
    onFeedback?: (
        messageId: string,
        segmentIdx: string,
        refId: string,
        type: "like" | "unlike",
        tags?: string[],
        content?: string
    ) => void;
    onCancelFeedback?: (messageId: string, segmentIdx: string, refId: string) => void;
    /** 点击跳转回调，用于合规校验 */
    onNavigate?: (doc: IThinkReference) => void;
    /** 流式输出中禁用点赞/点踩 */
    sseLoading?: boolean;
}

/**
 * 引用文献抽屉组件
 * 在页面右侧展示文献列表
 */
const ReferencesListBox: React.FC<IReferencesDrawerProps> = ({
    visible,
    segment,
    messageId,
    anchorIndex,
    paragraphIndex,
    triggerTimestamp,
    onClose,
    onFeedback,
    onCancelFeedback,
    onNavigate,
    sseLoading,
}) => {
    // 从 segment 解析 references 数据
    const { docs, totalCount } = useMemo<{ docs: IThinkReference[]; totalCount: number }>(() => {
        if (!segment?.content || (segment.type !== 'thinkProcessV2' && segment.type !== 'oeReferences')) {
            return { docs: [], totalCount: 0 };
        }
        try {
            const data = JSON.parse(segment.content);
            const references = data.references || [];
            return { docs: references, totalCount: references.length };
        } catch (e) {
            console.error("Failed to parse references from segment:", e);
            return { docs: [], totalCount: 0 };
        }
    }, [segment]);

    // 获取 segmentIdx
    const segmentIdx = segment?.segment_idx || "";

    return (
        <>
            {/* 抽屉 */}
            <div className={`${styles.drawer} ${visible ? styles.visible : ""}`}>
                <div className={styles.drawerContent}>
                    <ReferencesList
                        docs={docs}
                        totalCount={totalCount}
                        messageId={messageId}
                        segmentIdx={segmentIdx}
                        anchorIndex={anchorIndex}
                        paragraphIndex={paragraphIndex}
                        triggerTimestamp={triggerTimestamp}
                        onClose={onClose}
                        onFeedback={onFeedback}
                        onCancelFeedback={onCancelFeedback}
                        onNavigate={onNavigate}
                        sseLoading={sseLoading}
                    />
                </div>
            </div>
        </>
    );
};

export default ReferencesListBox;
